import { createStorage } from '@aviata/storage';

import { FAVORITES_ONBOARDING_STORAGE_KEY } from './config';

const storage = createStorage(localStorage);

export function wasFavoritesOnboardingShown() {
  return !!storage.parse(FAVORITES_ONBOARDING_STORAGE_KEY);
}

export function setFavoritesOnboardingShown() {
  storage.stringify(FAVORITES_ONBOARDING_STORAGE_KEY, true);
}
